import { getAppConfig } from "services/configService";
import { GET, PUT } from "services/httpService";

const apiUrl = () => {
  return getAppConfig().CustomerApiUrl;
};

export const getCustomerMe = requestInfo => {
  return GET(requestInfo, apiUrl() + "/customers/me");
};

export const putCustomerMe = (requestInfo, customer) => {
  return PUT(requestInfo, apiUrl() + "/customers/me", customer);
};
